<div class="configure-card"
     [class.active]="active"
     [class.completed]="completed">

  <div class="status-row">

    @if (completed) {
      <mat-icon
        svgIcon="circle_tick"
        class="status-completed-icon completed-icon">
      </mat-icon>
    }

    @if (active && !completed) {
      <mat-icon
        svgIcon="circle_dot"
        class="status-active-icon active-icon">
      </mat-icon>
    }

    @if (!active && !completed) {
      <mat-icon
        svgIcon="circle_dot"
        class="status-inactive-icon inactive-icon">
      </mat-icon>
    }

    <span class="status-text fs-16 fw-500"
          [class.text-disabled]="!active && !completed">
      {{ 'INSTANCE_SUMMARY.TABLE.CONFIGURE' | transloco }}
    </span>

  </div>
</div>
